import React from 'react';
import { inject, observer } from 'mobx-react';
import { CATALOG_ITEM_TYPES } from "./catalogItemTypes";
import { isModel } from "../../../services/utils";
import { PRICE_UNITS } from "./priceUnites";
import { ItemCategories } from "./itemCategories";
import { Form, Input, Select, Switch } from 'antd';
import './item.css';

@inject('currentItem')
@observer
export class Item extends React.Component {
    async componentDidMount() {
        if (!this.props.currentItem.type) {
            this.setType(CATALOG_ITEM_TYPES[0].value);
        }
    }

    setName = ({ target }) => this.props.currentItem.setProp('name', target.value);
    setType = (value) => {
        this.props.currentItem.setProp('type', value);
        this.props.currentItem.setMetadataProp('isContainer', false);
        this.props.currentItem.setMetadataProp('canBeContained', false);
        this.props.currentItem.setMetadataProp('isNonCollidable', false);
        this.props.currentItem.setMetadataProp('isNonRotatable', false);

        if (value === 'Pillow') {
            this.props.currentItem.setMetadataProp('canBeContained', true);
        }

        if (value === 'Rug' || value === 'Curtain') {
            this.props.currentItem.setMetadataProp('isNonCollidable', true);
        }
    };
    setPriceUnit = (value) => this.props.currentItem.setMetadataProp('priceUnit', value);
    setIsContainer = (checked) => this.props.currentItem.setMetadataProp('isContainer', checked);
    setCanBeContained = (checked) => this.props.currentItem.setMetadataProp('canBeContained', checked);
    setIsNonCollidable = (checked) => this.props.currentItem.setMetadataProp('isNonCollidable', checked);
    setNonRotatable = (checked) => this.props.currentItem.setMetadataProp('isNonRotatable', checked);

    render() {
        const { currentItem } = this.props;
        if (!currentItem) {
            return null;
        }
        const showIsContainer = currentItem &&
            (currentItem.type === 'FloorItem' || currentItem.type === 'WallItem' || currentItem.type === 'TwinBed' ||
                currentItem.type === 'Crib' || currentItem.type === 'ToddlerBed' || currentItem.type === 'QueenBed' ||
                currentItem.type === 'Bassinet');
        const showCanBeContained = currentItem && (currentItem.type === 'FloorItem');
        const showIsNonCollidable = showIsContainer || currentItem.type === 'Rug' || currentItem.type === 'Curtain';
        const meta = currentItem.metadata;

        return (
            <Form
                layout="horizontal"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
                style={{ maxWidth: 560, margin: '32px auto' }}
            >
                <Form.Item
                    label="Name"
                    validateStatus={!currentItem.name ? 'error' : ''}
                    help={!currentItem.name ? 'Required' : undefined}
                >
                    <Input value={currentItem.name ?? ''} onChange={this.setName} />
                </Form.Item>

                <Form.Item
                    label="Type"
                    validateStatus={!currentItem.type ? 'error' : ''}
                    help={!currentItem.type ? 'Required' : undefined}
                >
                    <Select
                        value={currentItem.type ?? undefined}
                        onChange={this.setType}
                        options={CATALOG_ITEM_TYPES
                            .filter(t => !t.deprecated || currentItem.type === t.value)
                            .map(t => ({
                                value: t.value,
                                label: t.deprecated ? `${t.label} (deprecated)` : t.label,
                                disabled: t.deprecated && currentItem.type !== t.value,
                            }))}
                    />
                </Form.Item>

                <Form.Item label="Categories" wrapperCol={{ span: 18 }}>
                    <ItemCategories
                        categoriesIds={currentItem.categoriesIds}
                        add={currentItem.addCategory}
                        update={currentItem.updateCategory}
                        remove={currentItem.removeCategory}
                    />
                </Form.Item>

                <Form.Item label="Price Unit">
                    <Select
                        value={meta.priceUnit}
                        onChange={this.setPriceUnit}
                        options={PRICE_UNITS.map(({ value, label }) => ({ value, label }))}
                    />
                </Form.Item>

                {showIsContainer && (
                    <Form.Item label="Is A Container?" valuePropName="checked">
                        <Switch checked={meta.isContainer} onChange={this.setIsContainer} />
                    </Form.Item>
                )}

                {showCanBeContained && (
                    <Form.Item label="Can Be Contained?" valuePropName="checked">
                        <Switch checked={meta.canBeContained} onChange={this.setCanBeContained} />
                    </Form.Item>
                )}

                {showIsNonCollidable && (
                    <Form.Item label="Is Non-Collidable?" valuePropName="checked">
                        <Switch checked={meta.isNonCollidable} onChange={this.setIsNonCollidable} />
                    </Form.Item>
                )}

                {isModel(currentItem.type) && (
                    <Form.Item label="Shouldn't Rotate?" valuePropName="checked">
                        <Switch checked={meta.isNonRotatable} onChange={this.setNonRotatable} />
                    </Form.Item>
                )}
            </Form>
        );
    }
}
